"use client";

import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeCustomizationProvider } from "@/contexts/ThemeCustomizationContext"; // Added
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ThemeCustomizationProvider> {/* Added */}
        <TooltipProvider>
          {children}
          <Toaster />
        </TooltipProvider>
      </ThemeCustomizationProvider>
    </AuthProvider>
  );
}
